import { TDeleteWaitersParams } from '../../../types/services';
import { asyncTimeout } from '../../../utils/asyncTimeout';
import { SERVICES_MOCK_DELAY } from '../../../utils/constants';

export const deleteWaiters = async (params: TDeleteWaitersParams) => {
  await asyncTimeout(SERVICES_MOCK_DELAY);
};
